<ion-icon *ngIf="icon.type === 'svg'" [src]="icon.value"></ion-icon>
<ion-icon *ngIf="icon.type === 'ionicon'" [name]="icon.value"></ion-icon>
